import { ILayersPathOpts, ISyncPathType } from '../../interfaces/services/filesystem/Paths'
import { IDownloadType } from '../../services/filesystem/startDownload'
import { getLayerImageFilename } from '../../services/images/parse-image-name'

// MAIN DIRS
export const DIR_FILES = 'files'
export const DIR_USERS = 'users'
export const DIR_WEB_SERVER = 'wserver'
export const DIR_EXTENSIONS = 'extensions'
export const DIR_MODULES = 'modules'
export const DIR_DOWNLOADS = 'downloads'
export const DIR_STATUS = 'status'
export const DIR_IMAGES = 'images'
export const DIR_CUSTOM_DOWNLOADS = `${DIR_DOWNLOADS}/custom`
export const DIR_LAYERS_IMAGES = `${DIR_DOWNLOADS}/${DIR_IMAGES}/layers`
export const DIR_BASEMAP_IMAGES = `${DIR_DOWNLOADS}/${DIR_IMAGES}/basemap`
export const DIR_DOWNLOAD_STATUS = `${DIR_DOWNLOADS}/${DIR_STATUS}`
export const DIR_SYNC = 'sync'
export const DIR_SYNC_REQUESTS = `${DIR_SYNC}/requests`
export const DIR_SYNC_FILES = `${DIR_SYNC}/files`
export const LAST_SYNC_FILENAME = 'last-sync.json'

// LAST_USER
export const FILE_LAST_USER = `${DIR_USERS}/last-user.json`
export const FILE_DISCOVERY = 'discovery.json'

// WEB SERVER
export const getModuleDirPath = (mfe_id?: string, mfe_version?: string): string => `${DIR_WEB_SERVER}/${DIR_MODULES}${mfe_id !== undefined ? `/${mfe_id}` : ''}${mfe_id !== undefined && mfe_version !== undefined ? `/${mfe_version}` : ''}`

// USER DATA
const DIR_MASTER = 'master'
const DIR_USER_ENTITY = 'entities'
const DIR_OTHER_ENTITY = '_other'
const FILE_USER_ENTITY = 'data.json'

const FILE_TOKEN = 'sessionToken.json'
export const FILE_LAST_FARMS = 'lastFarms.json'
const FILE_LAST_DOWNLOAD = 'last-download-data.json'

const getUserDir = (userId: number): string => `${DIR_USERS}/${userId}`
const getMasterDir = (userId: number): string => `${getUserDir(userId)}/${DIR_MASTER}`
export const getEntityDir = (userId: number): string => `${DIR_USERS}/${userId}/${DIR_USER_ENTITY}`
export const getUserTokenPath = (userId: number): string => `${getMasterDir(userId)}/${FILE_TOKEN}`
export const getLastFarmsPath = (userId: number): string => `${getEntityDir(userId)}/${DIR_OTHER_ENTITY}/${FILE_LAST_FARMS}`
export const getUserDownloadPath = (userId: number, filename?: string): string => `${getUserDir(userId)}/${DIR_DOWNLOAD_STATUS}${filename ? `/${filename}` : ''}`
export const getEntityDataPath = (userId: number, entity: string, uuid?: string): string =>
`${getEntityDir(userId)}/${entity}${uuid !== undefined ? `/${uuid}` : ''}/${FILE_USER_ENTITY}`
export const getDownloadPath = (userId: number, type: IDownloadType, image?: ILayersPathOpts): string => {
  let relativeDownloadPath = ''
  if (type === 'basemap') { relativeDownloadPath = DIR_BASEMAP_IMAGES } else if (type === 'layers') { relativeDownloadPath = `${DIR_LAYERS_IMAGES}${image?.image !== undefined ? `/${image.farm_uuid}/${image.field_uuid}/${getLayerImageFilename(image.image)}` : ''}` } else if (type === 'modules') { return getModuleDirPath() } else { relativeDownloadPath = DIR_CUSTOM_DOWNLOADS }

  return `${getUserDir(userId)}/${relativeDownloadPath}`
}
export const getSyncFilePath = (userId: number, type: ISyncPathType): string => {
  if (type === 'files') return `${getUserDir(userId)}/${DIR_SYNC_FILES}`
  if (type === 'requests') return `${getUserDir(userId)}/${DIR_SYNC_REQUESTS}`
  return `${getUserDir(userId)}/${DIR_SYNC_REQUESTS}`
}
export const getLastSyncFilePath = (userId: number): string => {
  return `${getUserDir(userId)}/${DIR_SYNC}/${LAST_SYNC_FILENAME}`
}
export const getLastDownloadDataFilePath = (userId: number) => `${getMasterDir(userId)}/${FILE_LAST_DOWNLOAD}`
export const getDiscoveryFilePath = (userId: number) => `${getMasterDir(userId)}/${FILE_DISCOVERY}`

export const getInitialDirs = (): string[] => ([
  DIR_USERS,
  DIR_FILES,
  DIR_WEB_SERVER,
  `${DIR_WEB_SERVER}/${DIR_MODULES}`,
  `${DIR_WEB_SERVER}/${DIR_EXTENSIONS}`
])

export const getUserDirs = (userId: number): string[] => ([
  getEntityDir(userId),
  getMasterDir(userId),
  `${getUserDir(userId)}/${DIR_DOWNLOADS}`,
  `${getUserDir(userId)}/${DIR_DOWNLOAD_STATUS}`,
  `${getUserDir(userId)}/${DIR_CUSTOM_DOWNLOADS}`,
  `${getUserDir(userId)}/${DIR_DOWNLOADS}/${DIR_IMAGES}`,
  `${getUserDir(userId)}/${DIR_LAYERS_IMAGES}`,
  `${getUserDir(userId)}/${DIR_BASEMAP_IMAGES}`,
  `${getUserDir(userId)}/${DIR_SYNC}`,
  getSyncFilePath(userId, 'requests'),
  getSyncFilePath(userId, 'files')
])
